import {useState, FC} from "react";
import {Box, MenuItem, Select} from "@mui/material";
import {SearchBox} from "@buildwitt/shapeshift-common/v2/searchBox";
import {makeStyles} from "tss-react/mui";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {contentTypes} from "@/constants";

const useStyles = makeStyles()((theme) => ({
	filterContainer: {
		marginBottom: theme.spacing(5),
		gap: theme.spacing(2),
		display: "flex",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column"
		}
	},
	filterSelect:{
		minWidth: "250px",
		"& .MuiSelect-select > span": {
			visibility: "visible"
		}
	},
	emptyMenuItem:{}
}));

interface IProps {
	searchTerm: string;
	contentType: string | undefined;
	onSearchChange: (searchTerm: string) => void;
	onContentTypeChange: (contentType: string | undefined) => void;
}

const EMPTY_CONTENT_TYPE = "Content Type";

export const NotesFilter:FC<IProps> = ({searchTerm, contentType, onSearchChange, onContentTypeChange}) => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const filterBy = contentType || EMPTY_CONTENT_TYPE;

	return (
		<Box className={classes.filterContainer}>
			<SearchBox
				value={searchTerm}
				onChange={e => onSearchChange(e.target.value ?? "")}
			/>
			<Select 
				value={filterBy} 
				className={classes.filterSelect} 
				variant="outlined" 
				onChange={value => {
					const newValue = value.target.value !== EMPTY_CONTENT_TYPE ? value.target.value : undefined;
					onContentTypeChange(newValue);
				}}
			>
				<MenuItem value={EMPTY_CONTENT_TYPE}>
					<span className={classes.emptyMenuItem}>{t("page_notes_all", "All")}</span>
				</MenuItem>
				{contentTypes.map((item, idx) => {
					return <MenuItem key={idx} value={item}>{t(`course_category_${item}`, item)}</MenuItem>
				})}
			</Select>
		</Box>
	);
}